var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "178",
        height: "134",
        viewBox: "0 0 178 134",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M0.0537109 133.106H177.144V0H0.0537109V133.106Z",
          fill: "#CE388A",
        },
      }),
      _c("path", {
        attrs: {
          d: "M86 133H0V60C47.4951 60 86 92.6846 86 133Z",
          fill: "#E781C0",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }